<template>
    <div class="row card-body" style="padding-top: 0px;padding-bottom: 5em;">
        <div class="card-header window-header" style="margin: 0px -10px 0px -10px; width: 105%;">
            <h4 style="margin: 0px;">{{ lang.em_location }}</h4>
		</div>
        <div class="window-body">
            <div class="row">
                <div class="col-12">
                    <ul class="nav nav-tabs">
                        <li class="nav-item" v-for="(i, idx) in menuTab" :key="'item'+idx">
                            <a href="#" @click.prevent="chosseTab(i)"
                                :class="['nav-link', (tabSelected==i.val) ? 'active' : '']"
                            >
                                {{ i.name }}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="row" v-if="tabSelected=='1'">
                <div class="col-md-12 ">
                    <label class="col-form-label">{{ lang.em_insert_html }}
                        <a href="https://maps.google.com/" target="_blank"> {{ lang.em_or_get_one }}</a>
                    </label>
                    <div class="input-group">
                        <input type="text" class="form-control" v-model="codeHTML" @input="extraerSRC" placeholder='E.g. <iframe src="https://www.google.com/maps/embed?pb=!1m14!...'>
                        <span class="input-group-text"
                            style="cursor:pointer;"
                            @click="codeHTML=null"
                        >{{ lang.em_clear }}</span>
                    </div>
                </div>
                <div class="col-12" style="margin-top: 20px;">
                    <template v-if="urlMapSrc!=null">
                        <iframe :src="urlMapSrc"
                            width="100%"
                            height="350"
                            style="border:0;"
                            allowfullscreen=""
                            loading="lazy"
                            referrerpolicy="no-referrer-when-downgrade"
                        ></iframe>
                    </template>
                    <iframe :src="urlMapDefault"
                        v-else
                        width="100%"
                        height="350"
                        style="border:0;"
                        allowfullscreen=""
                        loading="lazy"
                        referrerpolicy="no-referrer-when-downgrade"
                    ></iframe>
                </div>
                <div class="col-12 text-right" style="">
                    <label :for="showMap" :class="['checkSwitch', 'badge badge-light badge-xs']" style="border: 1px solid #ccc; box-shadow: none;">
                        <div class="iCheckswitch">
                            <input type="checkbox" :id="showMap" v-model="hideMap" @change="saveTriggers('hideMap')" />
                            <label class="iCheckswitch-label" :for="showMap">
                                <span class="iCheckswitch-inner"></span>
                            </label>
                        </div>
                        <span class="form-check-label-text" >
                            {{ lang.em_hide_map }}
                        </span>
                    </label>
                </div>
                <div class="col-12 text-center" style="">
                    <button type="button"
                        class="btn btn-success btn-lg"
                        @click="setUrlMap()"
                        :disabled="isDisabled"
                        style="width: 100px;border-radius: 20px;"
                    >
                    {{ lang.ec_save }}
                    </button>
                </div>
            </div>
            <div class="row" v-if="tabSelected=='2'">
                <div class="col-md-12 ">
                    <div class="alert alert-info" style="margin-top:10px; padding:5px;">
                        <p style="line-height:1; font-size:12px; margin-bottom:0px;">
                            <strong>{{ lang.em_showcase_desc1 }}</strong>
                            {{ lang.em_showcase_desc2 }}</p>
                        <small><i><strong>{{ lang.em_tip }}</strong> {{ lang.em_tip_text }}</i></small>
                    </div>
                </div>
                <div class="col-md-12 " v-if="isLoading">
                    <div class="loadingImg">
                        <Loader></Loader>
                    </div>
                </div>
                <div class="col-12" id="imgShowCase" v-else>
                    <div class="row">
                        <div class="col-3" >
                            <button class="btn btn-info" @click="addNewImg" :disabled="limitImg==sliderImg.length"><i class="fa fa-plus"></i> {{ lang.em_add_image }}</button>
                        </div>
                        <div class="col-9 text-right" >
                            <label :for="showCaseId" :class="['checkSwitch', 'badge badge-xs', showCaseActive ? 'badge-success' : 'badge-secondary']" style="border: 1px solid #ccc; box-shadow: none;height: 36px;transform: none;">
                                <div class="iCheckswitch">
                                    <input type="checkbox" :id="showCaseId" v-model="showCaseActive" @change="saveTriggers('showCaseActive')" />
                                    <label class="iCheckswitch-label" :for="showCaseId">
                                        <span class="iCheckswitch-inner"></span>
                                    </label>
                                </div>
                                <span class="form-check-label-text" >
                                    {{ lang.em_enabled }}
                                </span>
                            </label>
                        </div>
                    </div>
                    <input type="file" style="display:none;" ref="inputsliderImg" @change="subirImg($event)" accept="image/*" />
                    <draggable
                        tag="div"
                        class="row"
                        :list="sliderImg"
                        v-bind="dragAttcImg"
                        @start="isDragging(true)"
                        @end="isDragging(false)"
                        handle=".moveItem"
                        group="sections"
                        @change="moveSection"
                    >
                        <div v-for="(img, idx) in sliderImg" :key="idx" :class="['row_item_image', 'content-column']" >
                            <div class="content-column-row">
                                <!-- {{ img }} -->
                                <div :class="['sec-imagen', 'imagen-center', 'noneDescription']">
                                    <div class="input-group" :style="img.image_name ? 'display:none' : ''">
                                        <input type="text" class="form-control form-control-sm" @click="openFile(idx)" v-model="img.image_name"/>
                                        <label class="input-group-text" for="sliderImg" @click="openFile(idx)" >{{ lang.em_upload }}</label>
                                    </div>
                                    <div class="bd-example">
                                        <button class="btn btn-danger btn-remove" type="button" :style="!img.image ? 'display:none' : ''" @click="imageDeleted(idx)">
                                            <i class="fas fa-trash-alt"></i>
                                        </button>
                                        <div v-show="img.showLoading" class="loadingImg">
                                            <Loader></Loader>
                                        </div>
                                        <img :src="img.image" class="img-fluid previewImage" alt="Responsive image" :style="!img.image ? 'display:none;' : ''" @click="openFile(idx)"/>
                                        <!-- <button type="button" class="btn btn-info btn-rotate"
                                            :style="!img.image_name ? 'display:none' : ''"> -->
                                            <!-- <i class="fas fa-redo"></i> -->
                                            <!-- @click="rotateImage(idx)" -->
                                        <!-- </button> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </draggable>
                    <div class="row" style="margin-top:10px;">
                        <div class="col-6">
                            <div >
                                <h4 style="display:flex; gap: 0px 10px; align-items: center;">
                                    {{ lang.em_box_content }}
                                    <label :for="showContentId" :class="['checkSwitch', 'badge badge-light badge-xs']" style="border: 1px solid #ccc; box-shadow: none;transform: none; padding: 1px 5px;">
                                        <div class="iCheckswitch">
                                            <input type="checkbox" :id="showContentId" v-model="showContent" />
                                            <label class="iCheckswitch-label" :for="showContentId">
                                                <span class="iCheckswitch-inner"></span>
                                            </label>
                                        </div>
                                        <span class="form-check-label-text" >
                                            {{ lang.em_show_box }}
                                        </span>
                                    </label>
                                </h4>
                            </div>
                            <vue-editor
                                v-model="description"
                                :editor-toolbar="customToolbar"
                                class="descripImg"
                                :placeholder="lang.em_org_placeholder"
                                />
                                <!-- @text-change="setUpdate(idx)" -->
                        </div>
                        <div class="col-6 text-center">
                            <h4>{{ lang.em_slider_preview }}</h4>
                            <div :class="['slider_showCase', sliderImg.length > 1 ? 'show_next' : '']" :style="{ '--total-time': sliderImg.length * 5 + 's' }" v-if="sliderImg.length>0">
                                <img v-for="(img, idx) in sliderImg" :key="idx"
                                    :src="img.image ? img.image : imgDefault"
                                    :alt="img.image"
                                    :style="{ '--delay': idx * 5 + 's' }"
                                />
                                <div v-if="showContent" class="slider_container">
                                    <div v-html="description" class="slider_content"></div>
                                </div>
                            </div>
                            <img v-else
                                :src="imgDefault"
                                alt="default"
                                style=" width: 250px; height: 150px; object-fit:cover;"
                                @click="addNewImg"
                            />
                        </div>
                        <div class="col-12 text-center" style="margin-top:10px;">
                            <button type="button"
                                class="btn btn-success btn-lg"
                                :disabled="isDisabledSaveImg"
                                @click="showCaseSave()"
                                style="width: 100px;border-radius: 20px;">
                                {{ lang.ec_save }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import draggable from 'vuedraggable';
import { mapGetters } from "vuex";
import { VueEditor } from 'vue2-editor'
import Loader from '@/core/components/shared/Loader';
import './imgShowCase.scss';
export default {
    name:"editMapIframe",
    components: {
        Loader,
        VueEditor,
        draggable,
    },
    data(){
        return {
            cardItem: null,
            codeHTML : null,
            urlMapSrc : null,
            showMap: `showMap_${Math.random().toString(36).slice(2, 8)}`,
            hideMap: false,
            urlMapDefault : 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1517337.2149921788!2d-73.00297119894064!3d42.03140120496237!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89e3656de973bffd%3A0x45c6d03655830d1c!2sMassachusetts%2C%20EE.%20UU.!5e0!3m2!1ses-419!2sco!4v1702055332819!5m2!1sen-419!2sus',
            apis: null,
            isDisabled: true,
            isDisabledSaveImg: false,
            menuTab:[{
                name:'',
                val:'1',
            },
            {
                name:'',
                val:'2',
            }],
            lang: {
                em_location: '',
                em_insert_map: '',
                em_showcase: '',
                em_insert_html: '',
                em_or_get_one: '',
                em_clear: '',
                em_hide_map: '',
                ec_save: '',
                em_showcase_desc1: '',
                em_showcase_desc2: '',
                em_tip: '',
                em_tip_text: '',
                em_add_image: '',
                em_enabled: '',
                em_upload: '',
                em_box_content: '',
                em_show_box: '',
                em_slider_preview: '',
                em_org_placeholder: '',
                em_swal_title: '',
                em_swal_text: '',
                em_swal_confirm: '',
                ec_cancel: '',
                em_error_upload: '',
                ec_fail: '',
                ec_failed_save: '',
            },
            tabSelected: '1',
            sliderImg: [],
            showLoading: [false],
            refreshImg: 0,
            customToolbar: [
                [
                    "bold",
                    "underline",
                    // { align: "" },
                    // { align: "center" },
                    // { list: "bullet" },
                    // { color: [] },
                    "link",
                    "clean"
                ]
            ],
            limitImg: 4,
            description: null,
            showContent: false,
            showContentId: `showContentId_${Math.random().toString(36).slice(2, 8)}`,
            isLoading: false,
            imgDefault: window.urlmaster + 'images/no-image.png',
            activeIdx: null,
            showCaseId: `showCaseId_${Math.random().toString(36).slice(2, 8)}`,
            showCaseActive: false,
        };
    },
    created(){
        this.lang = this.$store.getters['ModApps/Marketea/lang'];
        this.menuTab[0].name = this.lang.em_insert_map;
        this.menuTab[1].name = this.lang.em_showcase;
        let t = this;
        let urlApis = this.$store.getters['ModApps/Marketea/urlApis'];
        this.apis = urlApis.bSite;
        t.cardItem = this.$store.getters['ModApps/Marketea/get_bsite_cardItem'];
        t.tabSelected = this.$store.getters['ModApps/Marketea/is_editShowCase'] || '1';
        console.log('cardItem', t.cardItem)
        this.getTriggersActive(this.cardItem);
    },
    methods: {
        chosseTab(i){
            this.tabSelected=i.val;
        },
        getTriggersActive(item){
            let tempOps = item.temp_opts || [];
            const locationTriggers = tempOps.filter(opt => opt.meta_key === 'location_triggers' && opt.template_id === item.template_id);
            if(locationTriggers.length > 0){
                try {
                    const triggers = JSON.parse(locationTriggers[0].meta_value);
                    this.showCaseActive = triggers.showCaseActive === 1;
                    this.hideMap = triggers.hideMap === 1;
                    console.log('triggers', triggers)
                } catch (e) {
                    console.error('Error parsing location_triggers:', e);
                    return false;
                }
            }
        },
        getMapa(item){
            let mapa = null;
            if(item.temp_opts && item.temp_opts.length>0){
                for (const key in item.temp_opts) {
                    if (Object.hasOwnProperty.call(item.temp_opts, key)) {
                        if(item.template_id==item.temp_opts[key].template_id){
                            if(item.temp_opts[key].meta_key=='map' && item.temp_opts[key].meta_value!=null && item.temp_opts[key].meta_value.length>0){
                                mapa = item.temp_opts[key].meta_value;
                            }
                        }
                    }
                }
            }
            return mapa;
        },
        extraerSRC(){
            let t = this;
            console.log('event input', t.codeHTML)
            setTimeout(() => {
                let iframe = t.codeHTML.split(' ');
                for (const i in iframe) {
                    if (iframe[i].indexOf('src="')>-1){
                        t.urlMapSrc= iframe[i].slice(5, iframe[i].length-1);
                    }
                }
                console.log('urlMapSrc', t.urlMapSrc)
            }, 200);
        },
        setUrlMap(editUrl){
            let t = this;
            if(t.urlMapSrc!=null && t.urlMapSrc.length){
                t.isDisabled = true;
                let formData = new FormData();
                // @ts-ignore
                formData.append("user_id", window.master_client);
                // @ts-ignore
                formData.append("org_id", window.localorgdata);
                formData.append("id", t.cardItem.id);
                formData.append("template_id", t.cardItem.template_id);
                formData.append("meta_key", 'map');
                formData.append("meta_value", t.urlMapSrc);
                formData.append("pusher_id", pusher.connection.socket_id);
                t.$store.dispatch('ModApps/Marketea/setTempOpts', formData)
                .then(r => {
                    console.log('setOptionsTemplate', r);
                    t.isDisabled = false;
                    setTimeout(() =>{
                        this.$parent.$emit('closed-lateral');
                    }, 400);
                })
                .catch(error => {
                    console.log(error);
                    t.isDisabled = false;
                    t.$notify({
                        group: "noti",
                        type: 'Error',
                        title: this.lang.ec_fail,
                        text: this.lang.ec_failed_save,
                        duration: 2000
                    });
                });
            }
        },
        openFile(idx) {
            console.log(this.$refs.inputsliderImg)
            if(this.$refs.inputsliderImg) {
                this.activeIdx = idx;
                setTimeout(() => {
                    this.$refs.inputsliderImg.click()
                }, 0);
            }
            return false;
        },
        addNewImg() {
            this.sliderImg.push({
                image: null,
                image_name: null,
                showLoading: false,
            });
            this.openFile(this.sliderImg.length - 1);
        },
        isDragging(t) {
            console.log('move', t) // t = true or false
            return t;
        },
        log: function (evt) {
            console.log('log', evt)
        },
        moveSection(){
            let t = this;
        },
        getShowCase(){
            this.isLoading = true;
            var formData = new FormData();
            formData.append("user_id", window.master_client);
            formData.append("org_id", window.localorgdata);
            formData.append("id", this.cardItem.id);
            formData.append("template_id", this.cardItem.template_id);
            formData.append("meta_key", 'showCase');
            this.sliderImg =[];
            window.master
            .post("getShowCase", formData)
            .then(result => {
                this.isLoading = false;
                console.log("getShowCase", result.data)
                let imgData = result.data.r.slider || [];
                this.description = result.data.r.contentBox;
                this.showContent = (result.data.r.showBox=='true');
                if(imgData.length > 0){
                    for (let i in imgData) {
                        let urlImg = null; //this.imgDefault;
                        if(imgData[i].filename){
                            urlImg = result.data.url + imgData[i].filename + '?v=' + (new Date()).getTime();
                        }
                        console.log("sliderImg item", urlImg)
                        if(urlImg){
                            this.sliderImg.push({
                                image: urlImg,
                                image_name: imgData[i].filename,
                                showLoading: false,
                            });
                        }
                    }
                }
            }).catch(err => {
                this.isLoading = false;
                console.log(err);
            });
        },
        loadPreview(event, file, printImg){
            let t = this;
            console.log('loadPreview', file);
            if (file) {
                var reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = function (e) {
                    printImg.image = e.target.result;
                };
                reader.onerror = function (error) {
                    console.log('Error: ', error);
                    printImg.image = t.imgDefault;
                };
            } else {
                    printImg.image = this.imgDefault;
            }
        },
        subirImg(event) {
            let t = this;
            let idx = this.activeIdx;
            const file = event.target.files[0];
            if (file) {
                this.isDisabledSaveImg = true;
                this.sliderImg[idx].showLoading = true;
                this.loadPreview(event, file, this.sliderImg[idx])
                var formData = new FormData();
                formData.append("user_id", window.master_client);
                formData.append("org_id", window.localorgdata);
                formData.append("imgFile", file, file.name);
                formData.append("imgOld", this.sliderImg[idx].image_name ? this.sliderImg[idx].image_name : '');
                formData.append("id", t.cardItem.id);
                formData.append("template_id", t.cardItem.template_id);
                formData.append("meta_key", 'showCase');
                formData.append("pusher_id", pusher.connection.socket_id);
                window.master
                .post("setShowCase", formData)
                .then(result => {
                    this.isDisabledSaveImg = false;
                    console.log('setShowCase', result.data);
                    this.sliderImg[idx].showLoading = false;
                    let urlImg = t.imgDefault; // imagen x defaul
                    if(result.data.status){
                        urlImg = result.data.url + result.data.filename + '?v=' + (new Date()).getTime();
                        this.sliderImg[idx].image_name = result.data.filename;
                        this.sliderImg[idx].image = urlImg;
                        this.description = result.data.contentBox;
                        this.showContent = result.data.showBox;
                    }else{
                        t.$notify({
                            group: "noti",
                            type: "error",
                            title: "Error:",
                            text: this.lang.em_error_upload,
                        });
                    }
                })
                .catch(err => {
                    this.sliderImg[idx].showLoading = false;
                    this.isDisabledSaveImg = false;
                    console.log(err);
                });
            }
        },
        showCaseSave() {
            let t = this;
            this.isDisabledSaveImg = true;
            this.isLoading = true;
            var formData = new FormData();
            formData.append("user_id", window.master_client);
            formData.append("org_id", window.localorgdata);
            formData.append("id", t.cardItem.id);
            formData.append("template_id", t.cardItem.template_id);
            formData.append("meta_key", 'showCase');
            formData.append("contentBox", this.description);
            formData.append("showBox", this.showContent ? 'true' : 'false');
            formData.append("pusher_id", pusher.connection.socket_id);
            window.master
            .post("setShowCase", formData)
            .then(result => {
                this.isDisabledSaveImg = false;
                this.isLoading = false;
                console.log('setShowCase', result.data);
                if(result.data.status){
                    this.description = result.data.contentBox;
                    this.showContent = (result.data.showBox=='true');
                }else{
                    t.$notify({
                        group: "noti",
                        type: "error",
                        title: "Error:",
                        text: "Image upload failed, please try again.",
                    });
                }
            })
            .catch(err => {
                this.isDisabledSaveImg = false;
                this.isLoading = false;
                console.log(err);
            });
        },
        imageDeleted (idx) {
            let t = this;
            t.$swal({
                title: this.lang.em_swal_title,
                text: this.lang.em_swal_text,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                confirmButtonText: this.lang.em_swal_confirm,
                cancelButtonText: this.lang.ec_cancel,
            }).then((result) => {
                if (result.value) {
                    this.sliderImg[idx].showLoading = true;
                    this.isDisabledSaveImg = true;
                    var formData = new FormData();
                    formData.append("user_id", window.master_client);
                    formData.append("org_id", window.localorgdata);
                    formData.append("id", t.cardItem.id);
                    formData.append("template_id", t.cardItem.template_id);
                    formData.append("meta_key", 'showCase');
                    formData.append("imgOld", this.sliderImg[idx].image_name ? this.sliderImg[idx].image_name : '');
                    formData.append("pusher_id", pusher.connection.socket_id);
                    window.master.post("setShowCase", formData)
                    .then(resultData => {
                        console.log('imageDeleted', resultData.data)
                        this.sliderImg[idx].showLoading = false;
                        this.isDisabledSaveImg = false;
                        this.getShowCase();
                    })
                    .catch(err => {
                        this.sliderImg[idx].showLoading = false;
                        this.isDisabledSaveImg = false;
                        console.log(err);
                    });
                }
            });
        },
        saveTriggers(fromTrigger) {
            let t = this;
            var formData = new FormData();
            if(fromTrigger=='showCaseActive'){
                if(this.showCaseActive){
                    this.hideMap = true;
                }
            }
            // si se activa el showCase, se oculta el mapa aunque el hideMap no este activo, para evitar que se muestre el mapa debajo del showCase
            const triggers = {
                showCaseActive: this.showCaseActive ? 1 : 0,
                hideMap: this.hideMap ? 1 : 0,
            };
            formData.append("user_id", window.master_client);
            formData.append("org_id", window.localorgdata);
            formData.append("id", t.cardItem.id);
            formData.append("template_id", t.cardItem.template_id);
            formData.append("meta_key", 'location_triggers')
            formData.append("meta_value", JSON.stringify(triggers));
            formData.append("pusher_id", pusher.connection.socket_id);
            window.master
            .post("setOptionsTemplate", formData)
            .then(result => {
                this.isLoading = false;
            })
            .catch(err => {
                this.isLoading = false;
                console.log(err);
            });
        },
    },
    watch: {
        langGetter() {
            this.lang = this.$store.getters['ModApps/Marketea/lang'];
            this.menuTab[0].name = this.lang.em_insert_map;
            this.menuTab[1].name = this.lang.em_showcase;
        },
        codeHTML: function(){
            console.log('watch codeHTML', this.codeHTML)
            if(this.codeHTML!=null && this.codeHTML.length>0){ this.isDisabled = false;}
            else{ this.isDisabled = true;}
        },
        tabSelected: function(){
            if(this.tabSelected=='2'){
                this.getShowCase();
            }
            if(this.tabSelected=='1'){
                this.urlMapSrc = this.getMapa(this.cardItem);
            }
        },
    },
    computed: {
        ...mapGetters("ModApps/Marketea", { langGetter: "lang" }),
        dragAttcImg() {
            return {
                animation: 200,
                group: "sections",
                disabled: false,
                ghostClass: "ghost",
            };
        },
    },
}
</script>
<style lang="scss" scoped>
.window-header{cursor: move;}
.card-header h4{font-size:24px;}
.col-form-label, .form-control, .input-group-text{
    font-size:18px;
}
.window-body {
    width: 100%;
    min-height: 550px;
    padding: 0px;
    overflow: hidden;
    overflow-y: auto;
    height: calc(100vh - 200px);
}
@media (max-width:767px){
    .window-body{
        height: 100%;
        max-height: 800px;
        padding-bottom: 20em;
    }
}
</style>
